import { cn } from '../lib/cn'
import Icon, { IconType } from './Icon'
import { Text } from './Text'

interface ButtonProps {
  children: React.ReactNode
  variant?: keyof typeof styles
  href?: string
  target?: string
  className?: string
  icon?: IconType
  iconPosition?: 'left' | 'right'
  disabled?: boolean
  onClick?: () => void
}

const styles = {
  default:
    'px-5 py-3 bg-primary text-inverse hover:bg-gradient-to-r hover:from-[#FC2548] hover:to-[#F11FAD]',
  vibrant:
    'px-5 py-3 bg-gradient-to-r from-[#FC2548] to-[#F11FAD] text-inverse hover:text-white hover:from-black hover:to-black',
  outline: 'px-4 py-2 text-primary border-2 border-solid border-black hover:text-inverse',
  inverse:
    'px-4 py-2 text-primary border-2 border-solid border-white text-white hover:bg-white hover:text-black',
  inverseDisabled:
    'px-4 py-2 text-primary border-2 border-solid border-white text-white opacity-40',
}

export default function Button({
  variant = 'default',
  iconPosition = 'right',
  children,
  className,
  target,
  icon,
  href,
  disabled,
  onClick,
}: ButtonProps) {
  const containerClass = cn(
    styles[variant],
    'transition-all flex items-center justify-center font-semibold overflow-hidden gap-x-2 rounded-xl lg:rounded-2xl',
    !disabled ? 'hover:bg-primary ' : '',
    className,
  )
  const content = (
    <>
      {icon && iconPosition === 'left' ? <Icon type={icon} /> : null}
      <Text.BodyLarge className='opacity-100'>{children}</Text.BodyLarge>
      {icon && iconPosition === 'right' ? <Icon type={icon} /> : null}
    </>
  )
  if (href) {
    return (
      <a
        href={!disabled ? href : '#'}
        className={containerClass}
        target={target}
        aria-disabled={disabled}
      >
        {content}
      </a>
    )
  }
  return (
    <button className={containerClass} onClick={onClick} disabled={disabled}>
      {content}
    </button>
  )
}
